import React from 'react';
import { Consultation } from '@/shared/types/generated';
import SessionDetailView from './SessionDetails/SessionDetailView';
import Modal from '@/shared/components/Modal';
import { Portal } from 'react-native-paper';
import SnackBar from '@/shared/components/SnackBar';
import useStore from '@/stores/useStore';

interface SessionDetailModalProps {
  consultation: Consultation;
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  isSessionToday: boolean;
  isJoinable: boolean;
  openProfileModal: () => void;
  onRequestHandled?: () => void;
}

const SessionDetailModal: React.FC<SessionDetailModalProps> = ({
  consultation,
  isVisible,
  setIsVisible,
  isSessionToday,
  isJoinable,
  openProfileModal,
  onRequestHandled,
}) => {
  const { snackbarState, clearSnackBar } = useStore();

  return (
    <Modal isVisible={isVisible} setIsVisible={setIsVisible}>
      <Portal.Host>
        <SessionDetailView
          consultation={consultation}
          onClose={() => setIsVisible(false)}
          isSessionToday={isSessionToday}
          isJoinable={isJoinable}
          openProfileModal={openProfileModal}
          onRequestHandled={onRequestHandled}
        />
        <SnackBar
          visible={snackbarState.open}
          onDismiss={clearSnackBar}
          message={snackbarState.message}
          severity={snackbarState.severity}
          hasNavBar={false}
        />
      </Portal.Host>
    </Modal>
  );
};

export default SessionDetailModal;
